import { useEffect, useRef } from 'react';
import { TabType } from './consts';

export const useMobileScrollNav = (activeTab: TabType) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scrollContainerRef.current) return;

    // Znajdujemy element z aktywanym tabem
    const activeElement = scrollContainerRef.current.querySelector(
      `[data-tab-id="${activeTab}"]`
    );

    if (activeElement && scrollContainerRef.current) {
      // Obliczamy pozycję dla centrowania
      const containerWidth = scrollContainerRef.current.clientWidth;
      const elementWidth = (activeElement as HTMLElement).offsetWidth;
      const elementLeft = (activeElement as HTMLElement).offsetLeft;

      // Centrujemy tab w środku kontenera
      const scrollLeft =
        elementLeft - containerWidth / 2 + elementWidth / 2;

      scrollContainerRef.current.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });
    }
  }, [activeTab]);

  return scrollContainerRef;
};
